import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReactDOM from 'react-dom';
import { default as config } from '../../config';
import Alert from 'react-s-alert';
import { Link } from 'react-router-dom';

const mapStateToProps = (state) => {
    return {
        session_is_authenticated: state.session.is_authenticated,
        pif_enabled: state.account.info.pif_enabled,
        sop_enabled: state.account.info.sop_enabled,
        account_inProgress: state.account.inProgress,
        addresses: state.account.addresses,
        carts: state.carts
    };
};

class AddButton extends Component {
    constructor(props) {
        super(props);
        this.mounted = false;
        this.handleOpen = this.handleOpen.bind(this);
        this.handleDocumentClick = this.handleDocumentClick.bind(this);

        this.handleAddToCart = this.handleAddToCart.bind(this);

        this.format_map = {
            playaway: 'Playaway',
            bookpack: 'Bookpack',
            view: 'View',
            launchpad: 'Launchpad',
            recorded_books: 'Recorded Books',
            accessory: 'Accessory'
        };

        this.state = {
            success: false,
            is_open: false
        };
    }

    componentDidMount() {
        this.mounted = true;
        document.addEventListener('click', this.handleDocumentClick, false);
    }

    componentWillUnmount() {
        this.mounted = false;
        document.removeEventListener('click', this.handleDocumentClick, false);
    }

    handleDocumentClick(event) {
        if (this.mounted) {
            if (!ReactDOM.findDOMNode(this).contains(event.target)) {
                if (this.state.is_open) {
                    this.setState({
                        is_open: false
                    });
                }
            }
        }
    }

    handleOpen(event) {
        if (event.type === 'mousedown' && event.button !== 0) {
            return false;
        }

        // event.stopPropagation();
        event.preventDefault();

        this.setState({
            is_open: !this.state.is_open
        });
    }

    handleAddToCart(event) {
        event.preventDefault();
        if (!this.props.session_is_authenticated) {
            Alert.error('You must be logged in to add to cart.');
            return;
        }

        let cart_id = event.target.getAttribute('data-cart_id');
        let cart = this.props.carts.find((cart) => cart._id === cart_id);
        let territory = [this.props.territory, 'WORLD'];
        let has_rights = false;
        let item_rights = this.props.item.sales_territory_rights;
        item_rights = typeof item_rights === 'string' ? [item_rights] : item_rights;

        for (const ter of territory) {
            has_rights = has_rights || item_rights.includes(ter);
        }

        if (!has_rights) {
            Alert.error('This title is not available in your territory.');
            return;
        }

        // is this an SOP cart?
        if (cart.sop_id) {
            let sop_sub = this.props.sop.find((sub) => sub.internal_id === cart.sop_id);

            // Only allowed formats based on subscription can be added.
            if (!config.allowed_sop_formats[sop_sub.format].includes(this.props.item.format)) {
                Alert.error(
                    `You cannot add a ${this.format_map[this.props.item.format] || 'Unknown'} to your ${
                        this.format_map[sop_sub.format]
                    } queue.`
                );
                return;
            }
        }

        // is this a PIF cart?
        if (cart.is_pif) {
            // Only allowed PIF formats can be added.
            if (!config.allowed_pif_formats.includes(this.props.item.format)) {
                Alert.error(
                    `You cannot add a ${this.format_map[this.props.item.format] || 'Unknown'} to Play it Forward.`
                );
                return;
            }
        }

        this.props.onClick(cart._id);
    }

    render() {
        let { account_inProgress, carts, session_is_authenticated, sop, pif_enabled, sop_enabled } = this.props;
        let primary_cart = carts.find((cart) => cart.is_primary);
        let pif_cart = carts.find((cart) => cart.is_pif);
        if (account_inProgress && session_is_authenticated) {
            return <div></div>;
        }

        return (
            <div className="button-dropdown" onClick={this.handleOpen}>
                <a href="#addto" role="button" className="button button-primary button-small button-full">
                    Add to <i className="pw pw-arrow-down pw-sm"></i>
                </a>
                <div className={`dropdown-content dropdown-content-flat ${this.state.is_open ? 'is-open' : ''}`}>
                    {session_is_authenticated ? (
                        <div className="add-to-buttons">
                            {pif_enabled ? (
                                <button
                                    type="button"
                                    className="button button-pif button-pill"
                                    data-cart_id={pif_cart._id}
                                    onClick={this.handleAddToCart}
                                >
                                    <i className="pw pw-pif-bug pw-lg pw-no-margin"></i> PIF
                                </button>
                            ) : null}

                            <button
                                type="button"
                                className="button button-primary button-pill"
                                data-cart_id={primary_cart._id}
                                onClick={this.handleAddToCart}
                            >
                                <i className="pw pw-cart pw-md"></i> Cart
                            </button>
                        </div>
                    ) : (
                        <div className="add-to-buttons">
                            <Link
                                to={{
                                    pathname: '/login',
                                    state: {
                                        nextPathname: window.location.pathname
                                    }
                                }}
                            >
                                Login to add to cart
                            </Link>
                        </div>
                    )}

                    <div className="add-to">
                        {sop_enabled ? (
                            <div>
                                <h6>SOP</h6>
                                <ul className="list-flat">
                                    {sop.map((sub) => {
                                        let cart = carts.find((cart) => cart.sop_id === sub.internal_id) || {
                                            _id: 'xxx'
                                        };
                                        return (
                                            <li key={`sop_add_${sub.internal_id}`}>
                                                <a href="#add" data-cart_id={cart._id} onClick={this.handleAddToCart}>
                                                    {sub.description}
                                                </a>
                                            </li>
                                        );
                                    })}
                                </ul>
                            </div>
                        ) : null}
                    </div>

                    <hr />
                    <div className="add-to">
                        {sop_enabled ? (
                            <div>
                                <h6>Wishlists</h6>
                                <ul className="list-flat">
                                    {carts
                                        .filter((cart) => cart.is_wishlist)
                                        .map((cart) => {
                                            return (
                                                <li key={`wl_add_${cart._id}`}>
                                                    <a
                                                        href="#add"
                                                        data-cart_id={cart._id}
                                                        onClick={this.handleAddToCart}
                                                    >
                                                        {cart.name}
                                                    </a>
                                                </li>
                                            );
                                        })}
                                </ul>
                            </div>
                        ) : null}
                    </div>
                </div>
            </div>
        );
    }
}

AddButton.defaultProps = {
    onClick: () => {}
};

export default connect(mapStateToProps)(AddButton);
